import { render, staticRenderFns } from "./chequesHistory.vue?vue&type=template&id=48f245ae"
import script from "./chequesHistory.vue?vue&type=script&lang=js"
export * from "./chequesHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports